import { OnboardingWizard } from 'components/organisms/onboarding_wizard';
import React from 'react';

const Onboarding = () => {
  return <OnboardingWizard />;
};

export default Onboarding;
